import { cn } from '@/lib/utils'

// Wraps a coach avatar in a living "presence": a soft breathing halo always, and sonar pulse
// rings while she's thinking. `color` themes it to the chosen coach.
export function CoachOrb({
  active = false,
  color,
  children,
}: {
  active?: boolean
  color: string
  children: React.ReactNode
}) {
  return (
    <span className="relative inline-flex items-center justify-center" style={{ color }}>
      {/* idle: calm rotating glow · active: undulating "speaking" blob + sonar rings */}
      {active ? <span className="coach-blob" aria-hidden="true" /> : <span className="coach-spin" aria-hidden="true" />}
      <span className="coach-halo" aria-hidden="true" />
      {active && (
        <>
          <span className="coach-ring" aria-hidden="true" />
          <span className="coach-ring" style={{ animationDelay: '0.65s' }} aria-hidden="true" />
        </>
      )}
      <span className={cn('relative sara-star', active && 'sara-star-active')}>{children}</span>
    </span>
  )
}
